var isObject = require('../lang/isObject');

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

module.exports = toObject;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/internal/toObject.js
 ** module id = 228
 ** module chunks = 1 2 4 6 8 9 11
 **/